
import { defineComponent } from '@nuxtjs/composition-api'
import HtmlBrandButton from '~/components/html/htmlBrandButton.vue'
import { AppointmentLink } from '~/assets/ts/appointment/AppointmentLink'

export default defineComponent({
  head: {},
  components: { HtmlBrandButton },
  props: ['shop'],
  setup(props) {
    const appointmentLink = new AppointmentLink().getAppointmentLink(
      props.shop.address.addressCountry,
      props.shop.shopId,
      props.shop.slug
    )
    return { appointmentLink }
  },
})
